import React, { useState } from 'react';
import { useQuery } from '@apollo/client/react';
import './AssignStandByDriverModal.scss';
import Modal from 'react-bootstrap/Modal';

import {
    GetAllDrivers,
    GetAllDrivers_getAllDrivers as Driver,
    GetLoadIdAndSandPo,
    GetLoadIdAndSandPo_getLoadIdAndSandPo as LoadIdAndSandPo,
    GetDriversInStandby,
    GetDriversInStandby_getDriversInStandby as standbyDriversForAssigning,
} from '../../../../types/schemaTypes';
import ModalHeaderTitle from '../../../AddLoads/ModalHeaderTitle';
import { Loading, Error, CustomButton, NoResult } from '../../../_common';
import { useStoreContext } from '../../../App/StoreProvider';
import { Col, OverlayTrigger, Row, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    GET_LOADID_AND_SANDPO,
    GET_DRIVERS_IN_STANDBY,
    GET_ALL_DRIVERS_BY_REGION,
} from '../../../../graphql/client/queries';

interface AddDriversToPoolProps {
    show: boolean;
    proppant: string | null;
    sandPO: string | null;
    transportationPO: string | null;
    lofa: string | null | undefined;
    jobName: string | null;
    jobId: number | null;
    proppantId: number | null;
    lofaId: number | null;
    regionId: number | null | undefined;
    onClickBack: () => void;
    onClickAssign: (
        driverId: number | null | undefined,
        driverName: string | null | undefined,
        loadId: number | null | undefined,
    ) => void;
    mutationLoading: boolean;
}

const AddDriversToPool = ({
    show,
    proppant,
    sandPO,
    transportationPO,
    lofa,
    jobName,
    jobId,
    proppantId,
    lofaId,
    regionId,
    onClickBack,
    onClickAssign,
    mutationLoading,
}: AddDriversToPoolProps): React.ReactElement => {
    const [searchPhrase, setSearchPhrase] = useState<string>('');

    const { loading: loadIdLoading, error: loadIdError, data: loadIdAndSandPoData, refetch: loadIdRefetch } = useQuery<
        GetLoadIdAndSandPo
    >(GET_LOADID_AND_SANDPO, {
        variables: {
            input: {
                jobId: jobId,
                lofaId: lofaId,
                proppantId: proppantId,
                sandPO: sandPO,
                transportationPO: transportationPO,
            },
        },
        fetchPolicy: 'network-only',
    });

    const {
        loading: standByDriversLoading,
        error: standByDriversError,
        data: standbyDriversForAssigningData,
        refetch: standbyDriversRefetch,
    } = useQuery<GetDriversInStandby>(GET_DRIVERS_IN_STANDBY, {
        variables: {
            jobId: jobId,
            lofaId: lofaId,
        },
        fetchPolicy: 'network-only',
    });

    const { loading, error, data, refetch } = useQuery<GetAllDrivers>(GET_ALL_DRIVERS_BY_REGION, {
        variables: { regionId },
        fetchPolicy: 'network-only',
    });

    if (loading || standByDriversLoading || loadIdLoading) {
        return <Loading />;
    }

    if (error) {
        return <Error error={error} />;
    }
    if (standByDriversError) {
        return <Error error={standByDriversError} />;
    }
    if (loadIdError) {
        return <Error error={loadIdError} />;
    }

    const standbyDrivers: standbyDriversForAssigning[] = [];
    if (
        standbyDriversForAssigningData &&
        standbyDriversForAssigningData.getDriversInStandby &&
        standbyDriversForAssigningData.getDriversInStandby.length !== 0
    ) {
        standbyDriversForAssigningData.getDriversInStandby.forEach(
            (element: standbyDriversForAssigning | null): void => {
                if (element !== null) {
                    standbyDrivers.push(element);
                }
            },
        );
    }

    const loadIdAndSandPo: LoadIdAndSandPo | null | undefined =
        loadIdAndSandPoData && loadIdAndSandPoData.getLoadIdAndSandPo;

    let filteredList: (Driver | null)[] | null | undefined = data && data.getAllDrivers;
    if (searchPhrase && searchPhrase.length > 0) {
        filteredList =
            filteredList &&
            filteredList.filter(driver => {
                return driver && driver.driverName.toLowerCase().includes(searchPhrase.toLowerCase());
            });
    }

    return (
        <Modal show={show} onHide={onClickBack} dialogClassName="AssignStandByDriverModal-Container">
            <Modal.Header className="AssignStandByDriverModal-Header">
                <Modal.Title className="AssignStandByDriverModal-HeaderContainer">
                    <ModalHeaderTitle
                        title="Assign a Driver"
                        onCancelClick={onClickBack}
                        hasBackButton={false}
                        backButtonTitle=""
                        onBackClick={onClickBack}
                        load={loadIdAndSandPo?.loadId?.toString()}
                        proppantName={proppant}
                        lofa={lofa}
                        jobName=""
                        sandPO={loadIdAndSandPo?.sandPO}
                    ></ModalHeaderTitle>
                </Modal.Title>
            </Modal.Header>

            {mutationLoading ? <Loading /> : ''}

            <Modal.Body className="AssignStandByDriverModal-BodyContainer">
                <Row className="assignDriver-row">
                    <span className="AssignStandByDriverModal-LabelText mt-3">Standby Drivers in Job Pool</span>
                </Row>
                <div className="Scrollable-Table">
                    <Table striped bordered  className="standbyDriversTable">
                        <thead className="Scrollable-Table-Item">
                            <tr className="Scrollable-Table-Item">
                                <th>Driver Name</th>
                                <th>Carrier Name</th>
                                <th>Minutes Since Load Requested</th>
                                <th>Minutes Since Load Rejected</th>
                                <th>Minutes Since Load Delivered</th>
                                <th>Distance to LOFA in miles</th>
                                <th className="AssignDriver-Btn-Container"></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: teams">
                            {standbyDrivers.length > 0 ? (
                                standbyDrivers.map(i => (
                                    <tr key={i['driverName']} className="Scrollable-Table-Item">
                                        <td>
                                            {i.driverPoolNotes ? (
                                                <>
                                                    {i.driverName}
                                                                                                        {i.isAvailable === false && (
                                                        <span
                                                            className="conv-icon off-shift DriverItem-BellyDumpIcon"
                                                            title="Driver not available"
                                                        >
                                                            <FontAwesomeIcon icon={['fas', 'ban']} color="#FF0000" />
                                                        </span>
                                                    )}
                                                    <span
                                                        className="conv-icon on-shift DriverItem-BellyDumpIcon"
                                                        title={
                                                            i.checkInWithBellyDump
                                                                ? 'Checked in with belly dump (hopper)'
                                                                : 'Checked in with box'
                                                        }
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={[
                                                                'fas',
                                                                i.checkInWithBellyDump ? 'dumpster' : 'cube',
                                                            ]}
                                                            color="#b6bd00"
                                                        />
                                                    </span>
                                                    <OverlayTrigger
                                                        placement="bottom"
                                                        delay={{ show: 250, hide: 400 }}
                                                        overlay={
                                                            <span className="AssignStandByDriverModal-DirectionsTooltip">
                                                                {i.driverPoolNotes}
                                                            </span>
                                                        }
                                                    >
                                                        <i className="material-icons AssignStandByDriverModal-InfoIcon">
                                                            info
                                                        </i>
                                                    </OverlayTrigger>
                                                </>
                                            ) : (
                                                <>
                                                    {i['driverName']}
                                                                                                        {i.isAvailable === false && (
                                                        <span
                                                            className="conv-icon off-shift DriverItem-BellyDumpIcon"
                                                            title="Driver not available"
                                                        >
                                                            <FontAwesomeIcon icon={['fas', 'ban']} color="#FF0000" />
                                                        </span>
                                                    )}
                                                    <span
                                                        className="conv-icon on-shift DriverItem-BellyDumpIcon"
                                                        title={
                                                            i.checkInWithBellyDump
                                                                ? 'Checked in with belly dump (hopper)'
                                                                : 'Checked in with box'
                                                        }
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={[
                                                                'fas',
                                                                i.checkInWithBellyDump ? 'dumpster' : 'cube',
                                                            ]}
                                                            color="#b6bd00"
                                                        />
                                                    </span>

                                                </>
                                            )}
                                        </td>
                                        <td>{i.carrierName}</td>
                                        <td>{i.loadRequested}</td>
                                        <td>{i.loadRejected}</td>
                                        <td>{i.loadDelivered}</td>
                                        <td>{i.distanceToLofa}</td>
                                        <td className="AssignDriver-Btn-Container">
                                            <button
                                                className="AssignDriver-Btn"
                                                onClick={() => {
                                                    setSearchPhrase('');
                                                    onClickAssign(
                                                        i['driverId'],
                                                        i['driverName'],
                                                        loadIdAndSandPo?.loadId,
                                                    );
                                                }}
                                            >
                                                Assign Driver
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={6} align={'center'}>
                                        No Standby Drivers Available
                                    </td>
                                    <td className="AssignDriver-Btn-Container"></td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>

                <Row>
                    <div className="AssignStandByDriverModal-AllDriversList">
                        <span className="AssignStandByDriverModal-LabelText mt-3">All Drivers</span>
                        <div className="AssignStandByDriverModal-SearchBar">
                            <input
                                type="text"
                                placeholder="Search"
                                className="SearchBar-Input AssignStandByDriverModal-SearchBar-Input"
                                onChange={event => setSearchPhrase(event.target.value)}
                            />
                        </div>
                        <hr className="AssignStandByDriverModal-Seperator"></hr>
                        <div className="AssignStandByDriverModal-LoadList-Container">
                            {filteredList && filteredList.length > 0 ? (
                                filteredList.map(
                                    (driver: Driver | null): React.ReactElement => (
                                        <div
                                            className="DriverItem-Container AssignStandByDriverModal-DriverItem-Container"
                                            key={driver?.driverId}
                                        >
                                            <Col>
                                                <div className="DriverItem-Name-Company-Container">
                                                    <div className="DriverItem-Name">
                                                        {/* {
                                                        driver?.trainingStatus === 2 ? (
                                                            <div className="expired"></div>
                                                        ) : 
                                                          driver?.trainingStatus === 3 ? (
                                                            <div className="pass"></div>
                                                        ) : (
                                                            <div className="fail"></div>
                                                        )} */}

                                                        {driver?.driverName}
                                                        {driver?.isAvailable === false && (
                                                        <span
                                                            className="conv-icon off-shift DriverItem-BellyDumpIcon"
                                                            title="Driver not available"
                                                        >
                                                            <FontAwesomeIcon icon={['fas', 'ban']} color="#FF0000" />
                                                        </span>
                                                    )}
                                                        {/* Server pre-filters to on-shift + available drivers. */}
                                                        <span
                                                            className="conv-icon on-shift DriverItem-BellyDumpIcon"
                                                            title={
                                                                driver?.checkInWithBellyDump
                                                                    ? 'Checked in with belly dump (hopper)'
                                                                    : 'Checked in with box'
                                                            }
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={[
                                                                    'fas',
                                                                    driver?.checkInWithBellyDump
                                                                        ? 'dumpster'
                                                                        : 'cube',
                                                                ]}
                                                                color="#b6bd00"
                                                            />
                                                        </span>
                                                    </div>
                                                    <div className="DriverItem-Company">{driver?.driverCompany}</div>
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="DriverItem-ButtonContainer AssignStandByDriverModal-DriverItem-ButtonContainer">
                                                    <CustomButton
                                                        title="Assign Driver"
                                                        isBordered
                                                        onClick={() => {
                                                            setSearchPhrase('');
                                                            onClickAssign(
                                                                driver?.driverId,
                                                                driver?.driverName,
                                                                loadIdAndSandPo?.loadId,
                                                            );
                                                        }}
                                                        isDisabled={false}
                                                    />
                                                </div>
                                            </Col>
                                        </div>
                                    ),
                                )
                            ) : (
                                <div className="AssignStandByDriverModal-LoadList-Container">
                                    <NoResult isModal={true} />
                                </div>
                            )}
                        </div>
                    </div>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default AddDriversToPool;

